import { createSvgIcon } from '@mui/material';
import { ProfileIcon } from './ProfileIcon';

export const LogoIcon = __BRIGHTY__
  ? createSvgIcon(
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 .666667C4 .298477 4.29848 0 4.66667 0h2.66666C7.70152 0 8 .298477 8 .666667V7.33333C8 7.70152 8.29848 8 8.66667 8H16c.3682 0 .6667.29848.6667.66667v1.64293c0 .2653.1053.5196.2929.7072l.0237.0236c.1875.1876.4418.2929.7071.2929h1.6429c.3682 0 .6667.2985.6667.6667v8c0 .3682-.2985.6667-.6667.6667h-1.6429c-.2653 0-.5196.1053-.7071.2929l-.0237.0237c-.1876.1875-.2929.4418-.2929.7071v1.6429c0 .3682-.2985.6667-.6667.6667H8c-.36819 0-.66667-.2985-.66667-.6667v-1.6429c0-.2653-.10535-.5196-.29289-.7071l-.02369-.0237c-.18754-.1876-.44189-.2929-.70711-.2929H4.66667C4.29848 20.6667 4 20.3682 4 20v-8c0-.3682.29848-.6667.66667-.6667h1.64297c.26522 0 .51957-.1053.70711-.2929l.20465-.2046c.12503-.125.19527-.2946.19527-.4714v-.72878c0-.17681-.07024-.34638-.19527-.47141l-.20465-.20465c-.18754-.18754-.44189-.29289-.70711-.29289H4.66667C4.29848 8.66667 4 8.36819 4 8V.666667ZM15.3333 20c.3682 0 .6667-.2985.6667-.6667v-6.6666c0-.3682-.2985-.6667-.6667-.6667H8.66667C8.29848 12 8 12.2985 8 12.6667v6.6666c0 .3682.29848.6667.66667.6667h6.66663Z"
        />
      </svg>,
      'BrightyIcon',
    )
  : __WOLFO__
    ? createSvgIcon(
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <g transform="scale(0.8) translate(2, 2)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.5 1L6.8 6.5L5.1 1H2L5.5 11L7.2 5.5L8.9 11L12 1H8.5ZM14 1L16 11H18L20 1H17L16 6L15 1H14Z"
              fill="currentColor"
            />
            <circle cx="18" cy="6" r="3" fill="currentColor" opacity="0.8" />
          </g>
        </svg>,
        'WolfoIcon',
      )
    : ProfileIcon;
